import React, { memo, useState, useEffect } from 'react';
import styles from './Sys.module.less';
import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import MessageLine from './SysLine';

import InfiniteScroll from 'react-infinite-scroller';
import { useCallback } from 'react';
import { getMessageList } from '../../../actions/message';

const selectMessage = createSelector(
  state => state.message,
  message => ({
    messageHot: message.hot,
    sysPagenation: message.sysPagenation,
    sysLoading: message.sysLoading,
    sysList: message.sysList || [],
  }),
);
export default memo(() => {
  const [node, setNode] = useState(null);
  const [commentIndex, setCommentIndex] = useState(-1);
  const dispatch = useDispatch();
  const {
    sysList,
    // messageHot,
    sysPagenation,
    sysLoading,
  } = useSelector(selectMessage);
  useEffect(() => {
    // if (messageHot && messageHot[1] === '1') {
    // dispatch(deleteMessageHot({ code: 1 }));
    // }
  }, []);

  const loadMore = useCallback(() => {
    if (!sysLoading) {
      dispatch(getMessageList({ code: 5, skip: sysList.length, limit: 24, refresh: false }));
    }
  });

  const handleCommentIndex = index => {
    setCommentIndex(index);
  };

  return (
    <div className={styles.sys} ref={r => setNode(r)}>
      <InfiniteScroll
        pageStart={1}
        loadMore={loadMore}
        hasMore={sysList.length < sysPagenation.count}
        loader={
          <div className="loader" key={0}>
            ----------加载中----------
          </div>
        }
        initialLoad={false}
        useWindow={false}
        getScrollParent={() => node}
      >
        {sysList?.map((comment, index) => (
          <MessageLine
            message={comment}
            key={comment.id}
            setCommentIndexCallback={handleCommentIndex}
            commentIndex={commentIndex}
            orderIndex={index}
          />
        ))}
      </InfiniteScroll>
    </div>
  );
});
